__webpack_require__.p = "https://app.hotspot.kau.se/";